var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcs1Socket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 90,
    viewBox: "0 0 67 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_19918)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.8697 90H20.1303C9.01651 90 0 81.0155 0 69.926C0 58.8433 9.00976 49.8521 20.1303 49.8521H46.8697C57.9835 49.8521 67 58.8366 67 69.926C67 81.0087 57.9902 90 46.8697 90Z",
    fill: "#172228"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.2095 52.69C28.196 52.5891 28.1892 52.4883 28.1892 52.3807L28.3241 48.9711C17.8779 46.5434 10.2843 37.0074 10.716 25.9247C11.2015 13.3558 21.8096 3.55752 34.4138 4.04172C47.018 4.52592 56.8438 15.1043 56.3582 27.6732C55.9536 38.2381 48.3938 46.8393 38.5073 49.0316L38.5343 52.7573C38.5343 52.7573 38.3589 52.7842 38.3589 52.7909C50.2888 50.5985 59.5346 40.4102 60.0201 27.8211C60.5866 13.2347 49.1828 0.954967 34.5554 0.390072C19.928 -0.168099 7.61379 11.1971 7.05405 25.7835C6.54826 38.9039 15.7199 50.148 28.2162 52.69H28.2095Z",
    fill: "#172228"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.465 86.9066H20.535C9.75834 86.9066 1.01833 78.191 1.01833 67.4445C1.01833 56.6981 9.75834 47.9825 20.535 47.9825H46.465C57.2417 47.9825 65.9817 56.6981 65.9817 67.4445C65.9817 78.191 57.2417 86.9066 46.465 86.9066Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5438 47.9422C21.2701 47.9422 11.2824 37.922 11.2824 25.6019C11.2824 13.2818 21.2701 3.2616 33.5438 3.2616C45.8176 3.2616 55.8052 13.2818 55.8052 25.6019C55.8052 37.922 45.8176 47.9422 33.5438 47.9422ZM33.5438 3.70544C21.5196 3.70544 11.7343 13.5306 11.7343 25.6019C11.7343 37.6732 21.5196 47.4983 33.5438 47.4983C45.5681 47.4983 55.3534 37.6732 55.3534 25.6019C55.3534 13.5306 45.5681 3.70544 33.5438 3.70544Z",
    fill: "#88D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5438 47.9825C45.8571 47.9825 55.839 37.9623 55.839 25.6018C55.839 13.2413 45.8571 3.22119 33.5438 3.22119C21.2306 3.22119 11.2487 13.2413 11.2487 25.6018C11.2487 37.9623 21.2306 47.9825 33.5438 47.9825Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2839 9.75795C45.2511 5.72298 39.6875 3.22803 33.5438 3.22803C24.5678 3.22803 16.8326 8.56091 13.2988 16.2341C13.926 18.4062 15.4029 20.3834 17.244 21.7553C19.9955 23.8064 23.4348 24.721 26.8202 25.2926C30.5563 25.9247 34.407 26.2072 38.1229 25.454C41.8388 24.7008 45.4197 22.8245 47.6789 19.7849C49.7897 16.9469 50.5585 13.0263 49.2839 9.75123V9.75795Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.5438 41.1567C42.0991 41.1567 49.0344 34.1926 49.0344 25.6019C49.0344 17.0112 42.0991 10.0471 33.5438 10.0471C24.9886 10.0471 18.0532 17.0112 18.0532 25.6019C18.0532 34.1926 24.9886 41.1567 33.5438 41.1567Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7532 19.8252C54.7532 31.4257 45.3186 40.8339 33.6855 40.8339C22.0523 40.8339 12.6177 31.4257 12.6177 19.8252C12.6177 19.0249 12.6649 18.2314 12.7526 17.4513C11.8287 19.9059 11.3229 22.5623 11.3229 25.3397C11.3229 37.7001 21.3038 47.7203 33.6113 47.7203C45.9188 47.7203 55.9064 37.7001 55.9064 25.3397C55.9064 22.764 55.468 20.2892 54.6723 17.9893C54.7262 18.5945 54.7599 19.2065 54.7599 19.8252H54.7532Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.4226 30C47.4226 32.5084 45.386 34.5394 42.8706 34.5394C40.3551 34.5394 38.3185 32.5084 38.3185 30C38.3185 27.4916 40.3551 25.4607 42.8706 25.4607C45.386 25.4607 47.4226 27.4916 47.4226 30Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1268 30.39C43.7078 30.39 44.1789 29.8902 44.1789 29.2737C44.1789 28.6572 43.7078 28.1573 43.1268 28.1573C42.5458 28.1573 42.0748 28.6572 42.0748 29.2737C42.0748 29.8902 42.5458 30.39 43.1268 30.39Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.6141 30C28.6141 32.5084 26.5775 34.5394 24.062 34.5394C21.5466 34.5394 19.5099 32.5084 19.5099 30C19.5099 27.4916 21.5466 25.4607 24.062 25.4607C26.5775 25.4607 28.6141 27.4916 28.6141 30Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8455 30.0538C41.8118 29.4015 42.3176 28.85 42.9717 28.8164C43.6259 28.7828 44.1789 29.2872 44.2126 29.9395C44.2463 30.5918 43.7405 31.1432 43.0864 31.1769C42.4322 31.2105 41.8792 30.7061 41.8455 30.0538Z",
    fill: "url(#paint0_linear_6_19918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6354 35.5279C38.6354 38.3322 36.356 40.6052 33.5438 40.6052C30.7317 40.6052 28.4522 38.3322 28.4522 35.5279C28.4522 32.7236 30.7317 30.4506 33.5438 30.4506C36.356 30.4506 38.6354 32.7236 38.6354 35.5279Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6353 18.7357C31.6353 21.54 29.3559 23.813 26.5437 23.813C23.7316 23.813 21.4521 21.54 21.4521 18.7357C21.4521 15.9314 23.7316 13.6583 26.5437 13.6583C29.3559 13.6583 31.6353 15.9314 31.6353 18.7357Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3703 18.1776C25.3703 17.4176 25.9503 16.799 26.6719 16.799C27.3935 16.799 27.9734 17.4176 27.9734 18.1776C27.9734 18.9375 27.3935 19.5562 26.6719 19.5562C25.9503 19.5562 25.3703 18.9375 25.3703 18.1776Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.8992 18.7357C27.8992 19.4822 27.2923 20.0875 26.5437 20.0875C25.7952 20.0875 25.1882 19.4822 25.1882 18.7357C25.1882 17.9893 25.7952 17.384 26.5437 17.384C27.2923 17.384 27.8992 17.9893 27.8992 18.7357Z",
    fill: "url(#paint1_linear_6_19918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.676 18.7357C45.676 21.54 43.3966 23.813 40.5844 23.813C37.7722 23.813 35.4928 21.54 35.4928 18.7357C35.4928 15.9314 37.7722 13.6583 40.5844 13.6583C43.3966 13.6583 45.676 15.9314 45.676 18.7357Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2828 18.1776C39.2828 17.4176 39.8628 16.799 40.5844 16.799C41.306 16.799 41.886 17.4176 41.886 18.1776C41.886 18.9375 41.306 19.5562 40.5844 19.5562C39.8628 19.5562 39.2828 18.9375 39.2828 18.1776Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.9332 18.7357C41.9332 19.4822 41.3262 20.0875 40.5776 20.0875C39.8291 20.0875 39.2289 19.4822 39.2289 18.7357C39.2289 17.9893 39.8358 17.384 40.5776 17.384C41.3195 17.384 41.9332 17.9893 41.9332 18.7357Z",
    fill: "url(#paint2_linear_6_19918)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.273 29.4956C23.273 28.9173 23.7113 28.4532 24.2576 28.4532C24.8038 28.4532 25.2422 28.9173 25.2422 29.4956C25.2422 30.074 24.8038 30.538 24.2576 30.538C23.7113 30.538 23.273 30.074 23.273 29.4956Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.3713 50.733C28.3578 50.6322 28.3511 50.538 28.3511 50.4304L28.4792 47.1285C18.35 44.7747 10.9924 35.5279 11.4038 24.7815C11.8759 12.5959 22.1602 3.09351 34.3868 3.56425C46.6066 4.035 56.1357 14.2906 55.6636 26.4829C55.2657 36.725 47.9352 45.0639 38.3589 47.189L38.3859 50.8003C38.3859 50.8003 38.2173 50.8272 38.2173 50.8339C49.783 48.7088 58.7455 38.8299 59.2176 26.6241C59.7639 12.4681 48.7107 0.564927 34.5284 0.0202056C20.3461 -0.524515 8.40282 10.4977 7.85657 24.6402C7.36427 37.3638 16.2594 48.265 28.3713 50.733Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0369 30.0538C23.0032 29.4015 23.509 28.85 24.1632 28.8164C24.8173 28.7828 25.3703 29.2872 25.404 29.9395C25.4377 30.5918 24.932 31.1432 24.2778 31.1769C23.6237 31.2105 23.0707 30.7061 23.0369 30.0538Z",
    fill: "url(#paint3_linear_6_19918)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8706 32.8446C40.5507 32.8446 38.6557 31.0491 38.4871 28.776C38.3792 29.1661 38.3185 29.5763 38.3185 30C38.3185 32.5084 40.3551 34.5393 42.8706 34.5393C45.386 34.5393 47.4226 32.5084 47.4226 30C47.4226 29.5696 47.3619 29.1593 47.2473 28.7626C47.0922 31.0423 45.1904 32.8446 42.8638 32.8446H42.8706Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0553 32.8446C21.7286 32.8446 19.8336 31.0423 19.6718 28.7693C19.5639 29.1593 19.4964 29.5696 19.4964 30C19.4964 32.5084 21.5331 34.5393 24.0485 34.5393C26.564 34.5393 28.6006 32.5084 28.6006 30C28.6006 29.5763 28.5399 29.1593 28.4253 28.7693C28.2634 31.049 26.3684 32.8446 24.0418 32.8446H24.0553Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5371 39.2939C30.9812 39.2939 28.8704 37.4311 28.4792 34.9967C28.459 35.1715 28.4522 35.3531 28.4522 35.5279C28.4522 38.3322 30.7317 40.6053 33.5438 40.6053C36.356 40.6053 38.6354 38.3322 38.6354 35.5279C38.6354 35.3329 38.6219 35.1379 38.6017 34.9496C38.2308 37.4042 36.1065 39.2939 33.5371 39.2939Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5844 22.5016C38.0217 22.5016 35.9042 20.6254 35.5265 18.1775C35.5063 18.3591 35.4928 18.5474 35.4928 18.7357C35.4928 21.54 37.7722 23.813 40.5844 23.813C43.3966 23.813 45.676 21.54 45.676 18.7357C45.676 18.5474 45.6625 18.3658 45.6423 18.1775C45.2579 20.6254 43.1403 22.5016 40.5844 22.5016Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5437 22.5016C23.9811 22.5016 21.8635 20.6254 21.4859 18.1775C21.4656 18.3591 21.4521 18.5474 21.4521 18.7357C21.4521 21.54 23.7316 23.813 26.5437 23.813C29.3559 23.813 31.6353 21.54 31.6353 18.7357C31.6353 18.5474 31.6218 18.3658 31.6016 18.1775C31.2172 20.6254 29.0997 22.5016 26.5437 22.5016Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3958 11.6543C60.9305 21.5064 59.8853 35.1849 51.2869 43.4969C48.5489 46.1869 45.2039 48.2784 41.542 49.4283C45.0151 47.9287 48.2117 45.77 50.7878 43.006C58.8804 34.5662 59.919 21.7619 54.4025 11.6476L54.3958 11.6543Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2624 49.4351C7.62053 43.5642 2.27267 20.8608 15.4838 7.78748C17.217 6.09279 19.166 4.6133 21.297 3.49023C17.2575 6.05917 13.8923 9.67046 11.7343 13.9274C4.8151 27.3369 11.3701 43.7929 25.2557 49.4351H25.2624Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2136 18.924C49.8167 22.6025 49.9448 27.7471 48.0566 31.7821C46.8899 34.1896 44.9881 36.1936 42.8706 37.7807C48.4679 32.3335 49.7425 26.2609 47.2136 18.924Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8857 34.5864C18.296 31.2306 17.48 26.1466 18.4444 21.9435C19.0513 19.4283 20.2989 17.2293 21.7758 15.427C18.0398 21.4391 17.8577 27.5924 20.8857 34.5864Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3493 21.7149C33.9147 18.9173 35.3916 14.8689 38.804 13.8467C35.8165 15.4808 34.6229 18.6886 36.3493 21.7149Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1673 14.2568C47.5575 16.3685 46.991 22.4747 42.1557 23.5978C46.4718 21.9098 46.8831 16.8392 43.1673 14.2568Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2749 21.7283C19.8404 18.9307 21.3173 14.8823 24.7296 13.8601C21.7421 15.4943 20.5485 18.7021 22.2749 21.7283Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0929 14.2704C33.4831 16.382 32.9167 22.4883 28.0813 23.6113C32.3974 21.9234 32.8088 16.8528 29.0929 14.2704Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.275 38.5272C26.8405 35.7297 28.3174 31.688 31.7297 30.6591C28.7422 32.2932 27.5486 35.501 29.275 38.5272Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0863 31.0625C40.4765 33.1741 39.91 39.2804 35.0747 40.4035C39.3907 38.7155 39.8021 33.6449 36.0863 31.0625Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2288 35.0101C32.2288 34.2502 32.8088 33.6315 33.5304 33.6315C34.2519 33.6315 34.8319 34.2502 34.8319 35.0101C34.8319 35.77 34.2519 36.3887 33.5304 36.3887C32.8088 36.3887 32.2288 35.77 32.2288 35.0101Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.8993 35.5279C34.8993 36.2743 34.2924 36.8796 33.5506 36.8796C32.8088 36.8796 32.1951 36.2743 32.1951 35.5279C32.1951 34.7814 32.802 34.1761 33.5506 34.1761C34.2991 34.1761 34.8993 34.7814 34.8993 35.5279Z",
    fill: "url(#paint4_linear_6_19918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2695 83.7794H20.7238C11.6736 83.7794 4.34303 76.4627 4.34303 67.4445C4.34303 58.4196 11.6803 51.1096 20.7238 51.1096H46.2695C55.3197 51.1096 62.6502 58.4264 62.6502 67.4445C62.6502 76.4694 55.3129 83.7794 46.2695 83.7794Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2695 81.9637H20.7238C11.9838 81.9637 4.86231 75.1311 4.39024 66.5366C4.37675 66.8392 4.34303 67.1419 4.34303 67.4445C4.34303 76.4694 11.6803 83.7794 20.7238 83.7794H46.2695C55.3197 83.7794 62.6502 76.4626 62.6502 67.4445C62.6502 67.1351 62.6233 66.8392 62.603 66.5366C62.1242 75.1311 55.0095 81.9637 46.2695 81.9637Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7238 53.5508H46.2695C54.9016 53.5508 61.9624 60.2152 62.5895 68.6617C62.6165 68.2583 62.6502 67.8548 62.6502 67.4378C62.6502 58.4129 55.3129 51.1029 46.2695 51.1029H20.7238C11.6736 51.1029 4.34303 58.4197 4.34303 67.4378C4.34303 67.848 4.37675 68.2583 4.40373 68.6617C5.0309 60.2152 12.0917 53.5508 20.7238 53.5508Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.0941 80.5111H20.9059C13.6698 80.5111 7.80262 74.6604 7.80262 67.4445C7.80262 60.2286 13.6698 54.3779 20.9059 54.3779H46.0941C53.3302 54.3779 59.1974 60.2286 59.1974 67.4445C59.1974 74.6604 53.3302 80.5111 46.0941 80.5111Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1454 74.4675C31.7787 70.4081 31.4241 64.1802 27.3533 60.5571C23.2825 56.9339 17.037 57.2875 13.4037 61.3469C9.77037 65.4063 10.125 71.6343 14.1958 75.2574C18.2666 78.8806 24.512 78.527 28.1454 74.4675Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7523 77.6257C54.1398 76.7633 57.806 71.709 56.9412 66.3367C56.0763 60.9643 51.0078 57.3083 45.6204 58.1707C40.233 59.0332 36.5667 64.0875 37.4315 69.4598C38.2964 74.8322 43.3649 78.4882 48.7523 77.6257Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8713 67.9019C24.8713 70.1547 23.0369 71.9839 20.7778 71.9839C18.5186 71.9839 16.6842 70.1547 16.6842 67.9019C16.6842 65.649 18.5186 63.8198 20.7778 63.8198C23.0369 63.8198 24.8713 65.649 24.8713 67.9019Z",
    fill: "url(#paint5_linear_6_19918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2734 67.9019C51.2734 70.1547 49.4391 71.9839 47.1799 71.9839C44.9207 71.9839 43.0864 70.1547 43.0864 67.9019C43.0864 65.649 44.9207 63.8198 47.1799 63.8198C49.4391 63.8198 51.2734 65.649 51.2734 67.9019Z",
    fill: "url(#paint6_linear_6_19918)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71787 74.23C6.2313 67.996 8.71978 59.6839 15.0118 56.2542C17.0619 55.0773 19.4964 54.6604 21.7624 54.6133C26.3077 54.5124 30.8193 54.5662 35.3444 54.6873C39.8628 54.8285 44.3812 55.0101 48.8928 55.3396C39.8696 55.6355 30.8126 55.4607 21.8028 55.7297C12.2198 55.3262 5.88737 65.696 9.71112 74.2367L9.71787 74.23Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17151 72.5689C-1.26784 62.6832 5.32089 50.9213 15.848 49.2871C14.6544 49.6839 13.5281 50.2017 12.4626 50.8338C4.71394 54.8352 0.72159 64.156 2.17151 72.5689Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1588 63.1472C60.0201 68.386 58.26 74.8352 53.5865 78.1237C48.5624 80.9751 42.6817 80.0739 37.1788 80.2757C33.5236 80.2555 29.8617 80.2151 26.2065 80.047C29.855 79.7377 33.5101 79.5628 37.1585 79.4014C42.412 78.9777 48.2791 79.778 53.02 77.3503C57.5924 74.2837 59.4199 68.4734 58.1588 63.1472Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4219 67.9019C65.8401 79.6234 56.0885 86.8595 44.9072 86.1735C47.4429 85.8575 49.9179 85.2724 52.3119 84.4856C59.7301 82.3269 64.5722 75.3867 65.4219 67.9019Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.2896 46.2206H28.6141V52.7572H39.2896V46.2206Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2896 46.2206H28.6141V52.7572H39.2896V46.2206Z",
    fill: "#0D1214"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_19918",
    x1: 43.0324,
    y1: 31.1769,
    x2: 43.0324,
    y2: 28.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_19918",
    x1: 26.5437,
    y1: 20.0875,
    x2: 26.5437,
    y2: 17.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_19918",
    x1: 40.5844,
    y1: 20.0875,
    x2: 40.5844,
    y2: 17.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_19918",
    x1: 24.2171,
    y1: -0.000019651,
    x2: 24.2171,
    y2: -0.000019651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_19918",
    x1: 33.5438,
    y1: 36.8796,
    x2: 33.5438,
    y2: 34.1829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_19918",
    x1: 20.7778,
    y1: 71.9839,
    x2: 20.7778,
    y2: 63.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_19918",
    x1: 47.1799,
    y1: 71.9839,
    x2: 47.1799,
    y2: 63.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_19918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs1Socket);
export default __webpack_public_path__ + "static/media/ccs1_socket.cb3e17a71d8422432d482dfc4ea7f04d.svg";
export { ForwardRef as ReactComponent };